module.exports = "\r\n<div class=\"box-span6 paddingr10\">\r\n\t<slot></slot>\r\n</div>\r\n";